// Module
var code = "<div class=\"loader formHeader\">\n    <asset cls=\"color{{$ctrl.colorName}}\" src=\"{{$ctrl.icon}}\"></asset>\n    <div class=\"color{{$ctrl.colorName}}\">Coming soon...</div>\n</div>\n";
// Exports
module.exports = code;